import * as React from 'react';

import { getUnitAddressesAsync } from '../../../../actions/DataActionExtension.g';
import Select from 'react-select';
import { Waiting } from '@msdyn365-commerce-modules/utilities';

export const AfricaCheckout: React.FC<any> = ({
    resources,
    customSetAddress,
    context,
    setIsVisible,
    setIsDisabled,
    filteredItems,
    setUnitName,
    setStakeNameAddress,
    defaultCountryRegionId,
    currentAddress
}) => {
    const [name, setName] = React.useState<string>('');
    const [stakeName, setStakeName] = React.useState<string>('');
    const [address, setAddress] = React.useState<any>([]);
    const [unit, setUnit] = React.useState<any>();
    const [isLoading, setIsLoading] = React.useState<any>(false);
    const [isDone, setIsDone] = React.useState<any>(false);
    const [showCity, setShowCity] = React.useState<any>(false);
    const [showState, setShowState] = React.useState<any>(false);
    const [options, setOptions] = React.useState<any>([]);
    const [wards, setWards] = React.useState<any>([]);
    const [stakes, setStakes] = React.useState<any>([]);
    const [currentOptionWard, setCurrentOptionWard] = React.useState<any>();
    const [currentOptionStake, setCurrentOptionStake] = React.useState<any>();

    React.useEffect(() => {
        if (currentAddress && currentAddress.Name && currentAddress.Name !== '') {
            setName(currentAddress.Name);
        }

        if (currentAddress && currentAddress.Street && currentAddress.Street !== '') {
            const streetSplit = currentAddress.Street.split('\n');
            const address = {
                Name: currentAddress.Name,
                Street: streetSplit[2] || '',
                City: currentAddress.City || '',
                StreetNumber: currentAddress.StreetNumber || '',
                State: currentAddress.State || '',
                ThreeLetterISORegionName: currentAddress.ThreeLetterISORegionName || defaultCountryRegionId || '',
                ZipCode: currentAddress.Zipcode || ''
            };
            setCurrentOptionWard({ label: streetSplit[0], value: streetSplit[0] });
            setUnitName(streetSplit[0]);
            setCurrentOptionStake({ label: streetSplit[1], value: streetSplit[1] });
            setStakeName(streetSplit[1]);
            setStakeNameAddress(streetSplit[1]);
            setUnit(address);
        }
    }, []);

    const getUnitAddress = async () => {
        const ctx = { callerContext: context.actionContext };
        setIsLoading(true);
        setIsDisabled(true);

        const unitAddress = await getUnitAddressesAsync(ctx, false, '', '')
            .then((res: any) => {
                setIsLoading(false);
                // setShowUnitSearch(false);
                const options = res.map((unit: any) => {
                    return { label: unit.UnitName, value: unit.UnitName };
                });
                const stakeOptions = options.filter((option: any) => {
                    return option.label.includes('Stake') || option.label.includes('stake');
                });
                const wardOptions = options.filter((option: any) => {
                    return option.label.toLowerCase().includes('ward') || option.label.toLowerCase().includes('branch');
                });
                setWards(wardOptions);
                setStakes(stakeOptions);
                setOptions(options);

                if (res && res[0] !== undefined && res[1] === undefined) {
                    if (options && options.length === 1) {
                        setCurrentOptionWard(options[0]);
                    }
                    const address = {
                        Name: name,
                        Street: res[0].Street || '',
                        City: res[0].City || '',
                        StreetNumber: res[0].StreetNumber || '',
                        State: res[0].State || '',
                        ThreeLetterISORegionName: res[0].CountryRegionId || defaultCountryRegionId || '',
                        ZipCode: res[0].Zipcode || ''
                    };
                    setUnitName(res[0].UnitName);
                    customSetAddress(address);
                    setAddress(res);
                    setUnit(address);
                } else if (res && res[0] !== undefined) {
                    // setCurrentOptionWard(null);
                    setAddress(res);
                    // setUnit({});
                } else if (res && res[0] === undefined) {
                    setIsVisible(false);
                }
            })
            .catch((err: any) => {
                setIsLoading(false);
                return console.log(err);
            });
        setIsDone(true);

        return unitAddress;
    };

    React.useEffect(() => {
        void getUnitAddress();
        if (filteredItems) {
            const hasCity = filteredItems.some((obj: any) => obj.hasOwnProperty('key') && obj.key === 'City');
            const hasState = filteredItems.some((obj: any) => obj.hasOwnProperty('key') && obj.key === 'State');
            setShowCity(hasCity);
            setShowState(hasState);
        }
    }, []);

    if (isLoading) {
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Waiting />
            </div>
        );
    } else if (options && isDone) {
        if (options) {
            options.sort((a: any, b: any) => {
                const labelA = a.label.toUpperCase();
                const labelB = b.label.toUpperCase();

                if (labelA < labelB) {
                    return -1;
                }
                if (labelA > labelB) {
                    return 1;
                }
                return 0;
            });
        }
        if (wards) {
            wards.sort((a: any, b: any) => {
                const labelA = a.label.toUpperCase();
                const labelB = b.label.toUpperCase();

                if (labelA < labelB) {
                    return -1;
                }
                if (labelA > labelB) {
                    return 1;
                }
                return 0;
            });
        }
        if (stakes) {
            stakes.sort((a: any, b: any) => {
                const labelA = a.label.toUpperCase();
                const labelB = b.label.toUpperCase();

                if (labelA < labelB) {
                    return -1;
                }
                if (labelA > labelB) {
                    return 1;
                }
                return 0;
            });
        }
        setIsVisible(true);
        const onChangeWard = (e: any) => {
            const selectedAddress = address.filter((unit: any) => {
                return unit.UnitName === e.value;
            });
            const newAddress: any = {};
            if (selectedAddress && selectedAddress[0]) {
                if (name && name !== '' && stakeName !== '') {
                    setIsDisabled(false);
                } else {
                    setIsDisabled(true);
                }
                setUnitName(selectedAddress[0].UnitName);
                setUnit(selectedAddress[0]);
                newAddress.Name = name ? name : '';
                newAddress.Street = selectedAddress[0] ? (selectedAddress[0].Street ? selectedAddress[0].Street : '') : '';
                newAddress.City = selectedAddress[0] ? (selectedAddress[0].City ? selectedAddress[0].City : '') : '';
                newAddress.StreetNumber = selectedAddress[0]
                    ? selectedAddress[0].StreetNumber
                        ? selectedAddress[0].StreetNumber
                        : ''
                    : '';
                newAddress.State = selectedAddress[0] ? (selectedAddress[0].State ? selectedAddress[0].State : '') : '';
                newAddress.ThreeLetterISORegionName = selectedAddress[0]
                    ? selectedAddress[0].ThreeLetterISORegionName
                        ? selectedAddress[0].ThreeLetterISORegionName
                        : selectedAddress[0].CountryRegionId
                        ? selectedAddress[0].CountryRegionId
                        : ''
                    : '';
                newAddress.ZipCode = selectedAddress[0] ? (selectedAddress[0].Zipcode ? selectedAddress[0].Zipcode : '') : '';
            }
            customSetAddress(newAddress);
        };
        const onChangeStake = (e: any) => {
            if (e && e.value !== '' && unit && unit.Street && name !== '') {
                setIsDisabled(false);
            } else {
                setIsDisabled(true);
            }
            const newAddress: any = {};
            setStakeName(e.value);
            setStakeNameAddress(e.value);
            newAddress.Name = name;
            newAddress.Street = unit ? (unit.Street ? unit.Street : '') : '';
            newAddress.City = unit ? (unit.City ? unit.City : '') : '';
            newAddress.StreetNumber = unit ? (unit.StreetNumber ? unit.StreetNumber : '') : '';
            newAddress.State = unit ? (unit.State ? unit.State : '') : '';
            newAddress.ThreeLetterISORegionName = unit
                ? unit.ThreeLetterISORegionName
                    ? unit.ThreeLetterISORegionName
                    : unit.CountryRegionId
                    ? unit.CountryRegionId
                    : ''
                : '';
            newAddress.ZipCode = unit ? (unit.Zipcode ? unit.Zipcode : '') : '';

            customSetAddress(newAddress);
            setUnit(newAddress);
        };

        // const setUnitSearch = async () => {
        //     // setShowUnitSearch(true);
        //     await getUnitAddress(false);
        //     setIsVisible(false);
        // };

        const nameChange = (value: string) => {
            if (value !== '' && unit && unit.Street && stakeName !== '') {
                setIsDisabled(false);
            } else {
                setIsDisabled(true);
            }
            const newAddress: any = {
                Name: value
            };
            setName(value);
            // setShowDefault(true);
            newAddress.Street = unit ? (unit.Street ? unit.Street : '') : '';
            newAddress.City = unit ? (unit.City ? unit.City : '') : '';
            newAddress.StreetNumber = unit ? (unit.StreetNumber ? unit.StreetNumber : '') : '';
            newAddress.State = unit ? (unit.State ? unit.State : '') : '';
            newAddress.ThreeLetterISORegionName = unit
                ? unit.ThreeLetterISORegionName
                    ? unit.ThreeLetterISORegionName
                    : unit.CountryRegionId
                    ? unit.CountryRegionId
                    : ''
                : '';
            newAddress.ZipCode = unit ? (unit.Zipcode ? unit.Zipcode : '') : '';

            customSetAddress(newAddress);
            setUnit(newAddress);
        };
        return (
            <div>
                <label
                    style={{
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: '19px',
                        marginLeft: '8px'
                    }}
                >
                    {resources.addressNameLabel}
                </label>
                <input
                    type='text'
                    name=''
                    id=''
                    style={{
                        border: '1px solid #878A8C',
                        borderRadius: '2px',
                        boxSizing: 'border-box',
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        lineHeight: '22px',
                        margin: '8px 0px',
                        padding: '8px',
                        width: '100%'
                    }}
                    value={name}
                    onChange={(e: any) => nameChange(e.target.value)}
                />
                <label
                    style={{
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: '19px',
                        marginLeft: '8px',
                        display: 'flex'
                    }}
                >
                    <div>{resources.africaUnitLabel}</div>
                    {/* <a onClick={() => setUnitSearch()} style={{ marginLeft: '20px' }}>
                        {resources.africaChangeUnitLabel}
                    </a> */}
                </label>
                <Select
                    placeholder='Select Ward'
                    options={wards}
                    onChange={(e: any) => onChangeWard(e)}
                    // defaultValue={options.length === 1 ? options[0] : undefined}
                    defaultValue={currentOptionWard}
                />
                <label
                    style={{
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: '19px',
                        marginLeft: '8px',
                        display: 'flex'
                    }}
                >
                    <div>{resources.africaStakeLabel}</div>
                    {/* <a onClick={() => setUnitSearch()} style={{ marginLeft: '20px' }}>
                        {resources.africaChangeUnitLabel}
                    </a> */}
                </label>
                <Select
                    placeholder='Select Stake'
                    options={stakes}
                    onChange={(e: any) => onChangeStake(e)}
                    // defaultValue={options.length === 1 ? options[0] : undefined}
                    defaultValue={currentOptionStake}
                />
                <label
                    style={{
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: '19px',
                        marginLeft: '8px'
                    }}
                >
                    {resources.addressStreetLabel}
                </label>
                <input
                    type='text'
                    name=''
                    id=''
                    style={{
                        border: '1px solid #878A8C',
                        borderRadius: '2px',
                        boxSizing: 'border-box',
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        lineHeight: '22px',
                        margin: '8px 0px',
                        padding: '8px',
                        width: '100%'
                    }}
                    value={(unit && unit.Street) || ''}
                    disabled={true}
                />
                {showCity && (
                    <>
                        <label
                            style={{
                                fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                lineHeight: '19px',
                                marginLeft: '8px'
                            }}
                        >
                            {resources.addressCityLabel}
                        </label>
                        <input
                            type='text'
                            name=''
                            id=''
                            style={{
                                border: '1px solid #878A8C',
                                borderRadius: '2px',
                                boxSizing: 'border-box',
                                fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                lineHeight: '22px',
                                margin: '8px 0px',
                                padding: '8px',
                                width: '100%'
                            }}
                            value={(unit && unit.City) || ''}
                            disabled={true}
                        />
                    </>
                )}
                {showState && (
                    <>
                        <label
                            style={{
                                fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                lineHeight: '19px',
                                marginLeft: '8px'
                            }}
                        >
                            {resources.addressStateLabel}
                        </label>
                        <input
                            type='text'
                            name=''
                            id=''
                            style={{
                                border: '1px solid #878A8C',
                                borderRadius: '2px',
                                boxSizing: 'border-box',
                                fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                lineHeight: '22px',
                                margin: '8px 0px',
                                padding: '8px',
                                width: '100%'
                            }}
                            value={(unit && unit.State) || ''}
                            disabled={true}
                        />
                    </>
                )}
                <label
                    style={{
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        lineHeight: '19px',
                        marginLeft: '8px'
                    }}
                >
                    {resources.addressThreeLetterISORegionNameLabel}
                </label>
                <select
                    id=''
                    style={{
                        border: '1px solid #878A8C',
                        borderRadius: '2px',
                        boxSizing: 'border-box',
                        fontFamily: '"Ensign:Sans",Arial,"noto sans" ,sans-serif',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        lineHeight: '22px',
                        margin: '8px 0px',
                        padding: '8px',
                        width: '100%'
                    }}
                    value={
                        unit
                            ? unit.ThreeLetterISORegionName
                                ? unit.ThreeLetterISORegionName
                                : unit.CountryRegionId
                                ? unit.CountryRegionId
                                : ''
                            : ''
                    }
                    disabled={true}
                >
                    <option
                        value={
                            unit
                                ? unit.ThreeLetterISORegionName
                                    ? unit.ThreeLetterISORegionName
                                    : unit.CountryRegionId
                                    ? unit.CountryRegionId
                                    : defaultCountryRegionId
                                    ? defaultCountryRegionId
                                    : ''
                                : defaultCountryRegionId
                                ? defaultCountryRegionId
                                : ''
                        }
                        selected
                    >
                        {unit
                            ? unit.ThreeLetterISORegionName
                                ? unit.ThreeLetterISORegionName
                                : unit.CountryRegionId
                                ? unit.CountryRegionId
                                : defaultCountryRegionId
                                ? defaultCountryRegionId
                                : ''
                            : defaultCountryRegionId
                            ? defaultCountryRegionId
                            : ''}
                    </option>
                </select>
            </div>
        );
    } else {
        return null;
    }
};
